import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { ROOM_SELECTION_OPTIONS } from '@/pages/Onboarding/options/RoomSelection';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenRoomSelection: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'RoomSelection',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const roomSelection = form.watch('room_selection');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['room_selection']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        roomSelection: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>Pick a room</OwnAiTitle>
        <OnboardingOptionsList>
          {ROOM_SELECTION_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={roomSelection === option.id}
              control={form.control}
              option={option}
              name="room_selection"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`room-selection-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
